var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.1V14.7C21 15.2775 20.7945 15.772 20.3836 16.1836C19.972 16.5945 19.4775 16.8 18.9 16.8H2.1C1.5225 16.8 1.0283 16.5945 0.6174 16.1836C0.2058 15.772 0 15.2775 0 14.7V2.1C0 1.5225 0.2058 1.0283 0.6174 0.6174C1.0283 0.2058 1.5225 0 2.1 0H18.9C19.4775 0 19.972 0.2058 20.3836 0.6174C20.7945 1.0283 21 1.5225 21 2.1ZM2.1 4.2H18.9V2.1H2.1V4.2ZM2.1 8.4V14.7H18.9V8.4H2.1ZM2.1 14.7V2.1V14.7Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.5116b8aa.svg";
export { ForwardRef as ReactComponent };